import styled from "styled-components";


export const ComboBoxContent = styled.div`
    visibility: hidden;
    display: block;
    position: absolute;
    background-color: ${({ theme }) => theme.bg3};
    min-width: 120px;
    max-width: 250px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 3;
    left: 0;
    margin-top: 10px;
    border-radius: 5px;
    max-height: 300px;
    padding: 0.5rem;
    a, span {
        cursor: pointer;
        font-size: 0.8rem;
        padding: 12px 16px;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {background-color: ${({ theme }) => theme.bg4}}
    }

`


export const ComboBoxContainer = styled.div`
    position: relative;
    display: inline-block;
    text-decoration: none;
    background-color: ${({ theme }) => theme.newBg2};
    padding: 0.6rem;
    border-radius: 5px;
    min-width: 100px;
    cursor: pointer;
    box-shadow: 0px 3px 10px 0px rgb(24 59 86 / 8%);
    > span {
        text-decoration: none;
    }
    &.open {
        .ComboBoxContent {
            visibility: visible;
            border-radius: 0 0 5px 5px;
        }
    }
    
`

export const ComboBoxInner = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .comboboxArrow {
        margin-left: 0.5rem;
    }
`

export const ComboBoxText = styled.div`
    text-decoration: none;
    width: 100%;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
`

export const ComboBoxTextPrefix= styled.div`
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 5px;
`